import React from 'react'
import ActionMenu from 'components/ActionMenu'
import { EditPencilIcon, RemoveIcon, MagicIcon, InfoBubbleIcon, CopyDashboardIcon } from 'images/common'
import { makeSelectFetchWorkspace } from 'containers/Settings/Workspace/selectors'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'

const ChartDotMenu = ({ onEdit, onDelete, onExplainKPI, onImproveChart, color, showAI = false, onCopy, workspace }) => {
  const dashboardBuildingAgentData = workspace.enabledAgents.find(agent => agent.name === 'dashboardBuilding')

  return (
    <>
      <ActionMenu
        onClick={() => onEdit()}
        icon={<EditPencilIcon />}
        text={'Edit chart'}
        color={color}
      />
      <hr />
      {showAI &&
        <>
          <ActionMenu
            onClick={() => onExplainKPI()}
            icon={<InfoBubbleIcon />}
            text={'Explain my KPI'}
            badge='AI'
            color={color}
          />
          {dashboardBuildingAgentData?.enabled &&
            <ActionMenu
              onClick={() => onImproveChart()}
              icon={<MagicIcon />}
              text={'Improve chart'}
              badge='AI'
              color={color}
            />
          }
        </>
      }
      <ActionMenu
        onClick={() => onCopy()}
        icon={<CopyDashboardIcon />}
        text={'Copy chart'}
      />
      <ActionMenu
        onClick={() => onDelete()}
        icon={<RemoveIcon />}
        text={'Remove chart'}
        color={color}
      />
    </>
  )
}

const mapStateToProps = createStructuredSelector({ workspace: makeSelectFetchWorkspace() })
const withConnect = connect(mapStateToProps)
export default withConnect(ChartDotMenu)